import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';

import { history } from 'Redux/store';
import PickAndMixPreselectedSegment from 'Components/PickAndMix/PickAndMixPreselectedSegment';

const PickAndMixPreselected = ({ preselections, bundleMessageType }) => {
  const hasPreselected = Array.isArray(preselections) && preselections.length > 0;

  if (!hasPreselected) {
    return (
      <div className="PickAndMixPreselectedTab PickAndMix__tab__preselectedContainer">
        <div className="h3 mb-5">
          <FormattedMessage
            id="pickandmixpreselected.noitems"
            defaultMessage="You’ve added all the pre-selected items to your basket. Check out now to get your {bundleType}!"
            values={{
              bundleType: bundleMessageType.toLowerCase(),
            }}
          />
        </div>

        <div className="PickAndMixPreselectedTab__noItemsContainer">
          <button className="btn btn-primary PickAndMixPreselectedTab__noItems__cartBtn PickAndMix__tab__noItems__cartBtn" onClick={() => history.push('/cart')}>
            <FontAwesomeIcon icon={faCartShopping} />
            <FormattedMessage id="pickandmixpreselected.gotocart" defaultMessage="Go to cart" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <section className="PickAndMixPreselectedTab PickAndMix__tab__preselectedContainer">
      <div className="PickAndMixPreselectedTab__shortDesc PickAndMixProductPage__content__shortDesc">
        <FormattedMessage
          id="pickandmixpreselected.shortdesc"
          defaultMessage="The following {bundleType} are curated collections from this bundle that we think you will like. You can either use them to help you start your bundle, or add them and go to cart."
          values={{
            bundleType: bundleMessageType.toLowerCase(),

          }}
        />
      </div>
      <div className="PickAndMixPreselectedTab__segmentContainer PickAndMix__tab__preselectedSegments">
        {hasPreselected && preselections.map((preselection =>
          <PickAndMixPreselectedSegment key={preselection.uniqueId} preselection={preselection} />
        ))}
      </div>
    </section>
  );
};

PickAndMixPreselected.propTypes = {
  preselections: PropTypes.arrayOf(PropTypes.shape({})),
  bundleMessageType: PropTypes.string,
};

PickAndMixPreselected.defaultProps = {
  preselections: [],
  bundleMessageType: '',
};

export default PickAndMixPreselected;
